var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5981 9.57173H21.6578C22.0944 9.56402 22.5187 9.71835 22.8496 10.0038C23.1814 10.2892 23.3966 10.6826 23.4552 11.1146V16.5144C23.3966 16.9464 23.1814 17.3398 22.8496 17.6252C22.5187 17.9107 22.0944 18.065 21.6578 18.0573H19.5981M19.5981 9.57173V18.0573M19.5981 9.57173H10.8966C10.5247 9.56402 10.1637 9.69514 9.87985 9.942C9.59674 10.1811 9.40929 10.5128 9.35374 10.8831L8.28924 17.8258C8.25607 18.0495 8.27068 18.2733 8.33317 18.4893C8.39565 18.7053 8.50366 18.8982 8.65023 19.0679C8.79679 19.2376 8.97885 19.3763 9.1825 19.4612C9.38693 19.5538 9.60835 19.6001 9.83206 19.6001H14.1982V22.6857C14.1982 23.3029 14.442 23.8891 14.8763 24.3211C15.3099 24.7531 15.8984 25 16.5125 25L19.5981 18.0573",
    stroke: "#505780",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutages);
export default __webpack_public_path__ + "static/media/Outages.3d46dc69f61f4377aaeb408abf2449e7.svg";
export { ForwardRef as ReactComponent };